import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { KybStepUi } from "@src/widgets/onboarding/ui/tours/MandatoryInitialSetup/steps/KybStepUi"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"

export class KybStep extends TourStepBase {
  component = KybStepUi
  name = `${ONBOARDING_TOURS.MANDATORY_INITIAL_SETUP}_Kyb`

  constructor() {
    super({ placement: TOUR_MODAL_PLACEMENTS.BOTTOM_RIGHT })
  }

  action() {
    return router.navigate({
      pathname: paths.kyb,
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      pic: this.name,
      subtitle: "Provide us with some basic information to get started",
      title: "KYB Verification",
    }
  }
}
